import * as React from 'react'
import WpApi from './wpapi'
import Loader from './Loader'
import AdviesAanvraag from './AdviesAanvraag'
import VoteGridModal from './modals/VoteGridModal'
import GridHeaderHelper from './GridHeaderHelper'
import GridHeader from './GridHeader'
import ListgridButtons from './ListgridButtons'

interface MyProps {
    type:string
    bbgroup:any
}
type MyState = {
    loading:boolean,
    filter_by_id?:number,
    options: any,
    pagination:any,
    permissions:any,
    rowcount:number,
    rows:Array<any>
}
interface cb_after_vote_event {
    (r:any): void;
}

class AdviesAanvragenList extends React.PureComponent<MyProps,MyState> {
    private fetchPromise ?: Promise<void>    
    private vote_popup =  React.createRef<VoteGridModal>()
    private callback_after_vote_event :cb_after_vote_event = (x)=>{ console.log("dummy")}

    constructor(props: MyProps) {
        super(props)
	this.open_popup = this.open_popup.bind(this)
	this.after_vote_event = this.after_vote_event.bind(this)	
	this.reset_filters = this.reset_filters.bind(this)

	this.state = {
	    pagination:{},
	    loading:false,
	    filter_by_id:undefined,
	    rowcount:0,
	    options:{},
	    permissions:{},
	    rows:[]
	}
    }
    public open_popup(e:any, cb:(r:any)=>void){
	this.callback_after_vote_event = cb
	console.log(e)
	let votetypes = [
	    'choice-vote',
	    'comment-vote'
	]

	if(votetypes.includes(e.cmd)){
	    this.vote_popup.current!.init(e)
	}else{
	    console.log(`ERROR unknown cmd ${e.cmd}`)
	    return
	}

    }
    click_col_header(e:any){
	let gh = new GridHeaderHelper()
	gh.click_col_header(e)
    }
    

    after_vote_event(v:any){
	console.log(`got vote-event kind ${v.kind}`)
	console.log(v)
	let d :{[name:string]:string}= {
	    post_id: v.post_id,
	    votetype: v.kind,
	}
	if(v.votetype !== undefined){
	    d.votetype = v.votetype
	}
	if(v.acf_key !== undefined){
	    d.acf_key = v.acf_key
	}
	if(v.kind === "add_comment"){

	    d.aspect = v.aspect
	    d.value = v.txt
	    d.level2 = v.level2
	    if(v.on_attr_id !== undefined){
		d.on_attr_id = v.on_attr_id
	    }
	}
	else if(v.kind === "update_comment"){
	    d.attr_id =  v.attr.attr_id
	    d.value = v.comment
	    if(v.on_attr_id !== undefined){
		d.on_attr_id = v.on_attr_id
	    }
	}
	else if(v.kind === 'remove_vote'){
	    d.attr_id = v.attr_id
	}
	else if(v.kind === 'chosen_option'){
	    d.value = v.value
	    d.is_final_field = v.is_final_field
	    d.trigger_recalc = v.trigger_recalc
	    d.aspect = v.aspect
	    if(d.acf_key === ""){
		d.acf_key = v.acf_key_select
	    }
	    if(v.on_attr_id !== undefined){
		d.on_attr_id = v.on_attr_id
	    }
	    d.level2 = v.level2
	    
	}
	else{
	    console.log('error unknown kind')
	    return
	}
	console.log(d)
	WpApi.do_post('/hd-attr',d, (r) => {
	    this.callback_after_vote_event(r)
	})
	
    }
    init_filtered(){
	this.setState({loading:true})
	if (this.fetchPromise) {
	    console.log(' already mounted previously')
	    return;
	}
	if(this.props.type === "zw-advies"){
	    if(this.state.filter_by_id !== undefined){
		this.fetch_single_hd(this.state.filter_by_id)
		return
	    }
	}
    }
    init(){
	this.setState({loading:true})
	let page_size = 100
	this.fetch_page(0,page_size)
    }    
    fetch_single_hd(post_id:number){
	let d = {
	    adviestype : this.props.type,
	    post_id : String(post_id)
	}
	this.fetchPromise = WpApi.do_get('/hd-adviesaanvragen', d,(r) => {
	    console.log(`fetched single`)
	    let perm = r.permissions
	    perm.bbgroup = this.props.bbgroup
		this.setState({
		    rowcount: r.rows.length,
		    rows  : r.rows,
		    options : r.options,
		    permissions: perm,
		    pagination: r.pagination,
		    loading:false
		})
	})
    }
    fetch_page(page:number,page_size:number){
	let d = {
	    adviestype : this.props.type,
	    page: String(page),
	    pagesize: String(page_size),
	    group_id : this.props.bbgroup.group_id
	}
	this.fetchPromise = WpApi.do_get('/hd-adviesaanvragen', d,(r) => {
	    console.log(`fetched page ${page} with page-size ${page_size}`)
	    let perm = r.permissions
	    perm.bbgroup = this.props.bbgroup
	    if(page == 0){
		this.setState({
		    rowcount: r.rows.length,
		    rows  : r.rows,
		    options : r.options,
		    permissions: perm,
		    pagination: r.pagination,
		    loading:false
		})
	    }else{
		console.log('append new rows')
		console.log(r.rows)
		this.setState(prevState => ({
		    rows: [...prevState.rows, ...r.rows]
		}))
	    }
	    let count_total = Number(r.pagination.count_total)
	    let max_page = Math.floor((count_total-0.01) / page_size)
	    if(page >= max_page){
		console.log("max pagecount reached")
	    }else{
		console.log(` get page ${page} of max_page ${max_page} , count_total ${count_total}`)
		this.fetch_page(page+1,page_size)
	    }
	})
    }
    componentDidMount(){
	if (this.fetchPromise) {
	    console.log(' already mounted previously')
	    return;
	}
	console.log('did mount')
	let p = new URLSearchParams(window.location.search)
	let fid = p.get('filter-by-id')
	if(fid !== null){
	    this.setState({ filter_by_id: Number(fid)},this.init_filtered)
	}else{
	    this.init()
	}
    }
    render_rows(){
	let init_expanded = this.state.filter_by_id !== undefined
	return this.state.rows.map((row, i) => {
	    if(row.hd === undefined){
		console.log('oops row has no hd')
		console.log(row)
		return null
	    }
	    let options = this.state.options
	    options.config = {
		view: "adviesaanvragen-list"
	    }
	    return (
		<AdviesAanvraag
		key={i} row={row}
		expanded={init_expanded}
		type={this.props.type}
		    cb_parent={this.open_popup}
		options={options}
		permissions={this.state.permissions}

		/>
	    )
	})
	
    }    
    render_header(){
	let zwstatus_options : {[k:string]:string} = {
	    '' : '-kies-',
	    'afgerond' : 'Afgerond',
	    'niet-afgerond' : 'In behandeling',
	    'leeg' : '(leeg)'
	}
	let coach_status_options  : {[k:string]:string} = {
	    '' : '-kies-',
	    'afgerond' : 'Afgerond',
	    'niet-afgerond' : 'In behandeling',
	    'leeg' : '(leeg)'
	}
	if(!(this.state.options.coach_help === undefined)){
	    Object.entries(this.state.options.coach_help.huidig.choices).map(([k,v]:[string,any],i:number)=>{
		if(k !== 'kies'){
		    coach_status_options[k] = v
		}
	    })
	}

	if(!(this.state.options.zwadvies === undefined || 
	    this.state.options.zwadvies.huidig === undefined)){
	    Object.entries(this.state.options.zwadvies.huidig.choices).map(([k,v]:[string,any],i:number)=>{
		if(k !== 'kies'){
		    zwstatus_options[k] = v
		}
	    })
	}

	let columns : {[k:string]:any} = {
	    'date' : {label:'Laatste wijziging',type:'date'},
	    'adres': {label: 'Adres',type:'txt'},
	    'level1': {label: 'Betreft',type:'txt'},
	    'level2': {label: 'Onderdeel',type:'txt'},
	    'adviseur': {label: 'Extern-adviseur',type:'txt'},
	    'invoer_aantal_todo': {label: 'Aantal lege verplichte invoervelden',type:'int'},
	    'wijkgenoten': {label: 'Aantal wijkgenoten in de groep',type:'int'},
	    'coach': {label: 'ZW-contactpersoon', type:'txt'},
    	    'coach_status': {label: 'ZW-contactpersoon-status', type:'select',options:coach_status_options},
	    'status': {label: 'Extern-advies-status',type:'select',options:zwstatus_options}
	}
    
     	let keys =  [
	    'adres','level1','status','adviseur','date'
       	]
	if(this.props.type === "zw-advies" ){
	    columns.date.label = 'ZW-advies laatste wijziging'
	    columns.status.label = 'ZW-advies-status'
	    columns.adviseur.label = 'ZW-adviseur'
    	    keys = [
		'adres','wijkgenoten', 'invoer_aantal_todo','status', 'adviseur','coach','coach_status','date'
    	    ] 
     	}
	let options_zwa : {[k:string]:string} = {
	    "" : "-kies-",
	    "leeg" : "Leeg",
	    "niet-leeg" : "Niet leeg",
	}
	if(this.state.options.zwadvies !== undefined){
	    let choices = this.state.options.zwadvies.huidig.choices
	    for(var lab of Object.values(choices)){
		if(typeof lab === "string"){
		    if(lab !== '-kies-'){
			options_zwa[lab] = lab
		    }
		}
	    }
	}
	return <GridHeader 
		columns={columns}
		columnkeys={keys}
		skip_level2={false}
		single_supplier_mode={false}
		/>

    }
    reset_filters(){
	console.log('reset-filters')
	this.setState({filter_by_id:undefined})
	let gh = new GridHeaderHelper()
	gh.reset_filters()
	this.init()
    }
    render(){
	let total = this.state.pagination.count_total
	if(this.state.filter_by_id !== undefined){
	    return (
	    <div className={"hd-actions-react listgrid adviesaanvragen "+this.props.type}>
    		<div>
                   <span className="cf-button reset-filters" onClick={this.reset_filters}>Toon alle huisdossiers</span>
                   {this.render_rows()}
               </div>
		<VoteGridModal ref={this.vote_popup}
		cb_parent={this.after_vote_event} post_id="undef" />
	    </div>
	    )
	}

	return (
	    <div className={"hd-actions-react listgrid adviesaanvragen "+this.props.type}>
		{this.state.loading ? <Loader /> : null}
	         {this.render_header()}
		 <div> {this.state.rows.length} / {total} huisdossiers</div>
		<div className="body">
		{this.render_rows()}
	    </div>
		<VoteGridModal ref={this.vote_popup}
		cb_parent={this.after_vote_event} post_id="undef" />
	    
	    </div>
	)
    }
}

export default AdviesAanvragenList
